import {Account} from "../../authProvider";

export class SwitchUserError extends Error {
    constructor(public message: string, public user: Account) {
        super(message);
    }
}
